import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const InfoMenuIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="info menu icon">
      {/* <title>info menu icon</title> */}
      <path
        d="M10.8191 3.26404C11.5643 2.91199 12.4356 2.91199 13.1808 3.26404L19.0536 6.03865C20.0397 6.50454 20.0654 7.85503 19.0976 8.35567L13.2689 11.3711C12.4761 11.7812 11.5239 11.7812 10.731 11.3711L4.9023 8.35567C3.93457 7.85503 3.96025 6.50454 4.94635 6.03865L10.8191 3.26404Z"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7087 9.5918L19.0536 10.6996C20.0397 11.1655 20.0654 12.516 19.0976 13.0166L13.2689 16.0321C12.4761 16.4422 11.5239 16.4422 10.731 16.0321L4.90231 13.0166C3.93457 12.516 3.96025 11.1655 4.94635 10.6996L7.29118 9.5918"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7087 14.252L19.0536 15.3598C20.0397 15.8257 20.0654 17.1762 19.0976 17.6768L13.2689 20.6922C12.4761 21.1024 11.5239 21.1024 10.731 20.6922L4.90231 17.6768C3.93457 17.1762 3.96025 15.8257 4.94635 15.3598L7.29118 14.252"
        stroke="#202123"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoMenuIcon;
